import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "graphWithMagnificationAndGear",
    iconColor: "white",
    text: "AI enabled slow job \nprediction to prevent \nSLA breach",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "peopleConnectedByGear",
    iconColor: "white",
    text: "End to end operations \nlineage for business \nimpact",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithPersonAndMessageBubble",
    iconColor: "white",
    text: "AI assisted ticket \nanalysis and routing",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "ai",
    iconColor: "white",
    text: "Reliability of data \nthrough AI driven smart\ndata quality",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_DNA1_3 = {
  title: "MEETING OR EXCEEDING ON-TIME AVAILABILITY",
  titleNumber: "3.",
  text: "Proactive pipeline monitoring to ensure availability, scalability and reliability of data and AI \nproducts through Pipeline Monitoring Module.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage(1044),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(103),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  demoButtons: [
    {
      label: "DATA OPERATIONS WORKBENCH DEMO",
      onClick: () => {
        setPreviousPage(104);
        setCurrentPage(105);
      },
      endIcon: "play",
    },
  ],
};
